export default class StickyMenu {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.reset();
      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Sets/Resets the menu
  //===========================================================================

  reset() {
    this.setState();
    this.adjustStickyMenu();
  }

  //===========================================================================
  // Sets the object state
  //===========================================================================

  setState() {
    this.state = {
      $stickyMenu: $('.js-sticky-menu'),
      $stickyContainer: $('.js-sticky-container'),
      $header: $('.js-header'),
      topPadding: 30
    };
  }

  //===========================================================================
  // Adjusts the position of the sticky menu
  //===========================================================================

  adjustStickyMenu() {
    if (this.state.$stickyMenu[0] && this.state.$stickyContainer[0]) {
      const $padding = this.state.$stickyMenu.find('.js-header-padding');
      const paddingHeight = $padding.css('display') && $padding.css('display') !== 'none' ? $padding[0].offsetHeight : 0;
      const topBoundary = this.state.$header[0] ? this.state.$header[0].offsetHeight + this.state.topPadding : this.state.topPadding;
      const menuBounds = this.state.$stickyMenu[0].getBoundingClientRect();
      const containerBounds = this.state.$stickyContainer[0].getBoundingClientRect();
      const containerBottom = containerBounds.top + containerBounds.height;

      if (containerBounds.top <= topBoundary && containerBounds.height > (menuBounds.height - paddingHeight)) {
        if (containerBottom <= menuBounds.height) {
          this.state.$stickyMenu.removeClass('fixed');
          this.state.$stickyMenu.addClass('absolute');
        } else {
          this.state.$stickyMenu.removeClass('absolute');
          this.state.$stickyMenu.addClass('fixed');
        }
      } else {
        this.state.$stickyMenu.removeClass('fixed');
        this.state.$stickyMenu.removeClass('absolute');
      }
    }
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(window).on('resize', this.adjustStickyMenu.bind(this));
    $(window).on('scroll', this.adjustStickyMenu.bind(this));
    $(document).on('historyChange', this.reset.bind(this));
  }
}
